import { useEffect } from 'react'

export function usePageTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} - Genealogic` : 'Genealogic'
    return () => { document.title = 'Genealogic' }
  }, [title])
}
